// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tJH-","question":"styles_question__ll-Dk","description":"styles_description__UgGHI"};